<template>
  <div class="columns is-multiline">
    <div class="column is-full">
      <b-field label="Filtrar por marca">
        <b-taginput v-model="tagsBrand" :data.sync="brands" autocomplete :allow-new="false" :open-on-focus="true" icon="label" placeholder="Marca..." @typing="getFilteredBrands" field="brand">
          <template slot-scope="props">
            <strong>{{props.option.brand}}</strong>
          </template>
          <template slot="empty">
            No hay marcas disponibles
          </template>
        </b-taginput>
      </b-field>
    </div>
    <div class="column is-full">
      <ColorFilter v-model="tagsColors" :data="colors" label="Filtrar por color" />
    </div>
    <div class="column is-full">
      <CheckboxFilter v-model="tagsCategories" :data="categories" label="Filtrar por categoria" />
    </div>
    <div class="column is-full">
      <CheckboxFilter v-model="tagsBracup" :data="bracup" label="Filtrar por copa" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ColorFilter from '@/components/ColorFilter'
import CheckboxFilter from '@/components/CheckboxFilter'
export default {
  props: ['value'],
  components: {
    ColorFilter,
    CheckboxFilter
  },
  data () {
    return {
      brands: [],
      categories: {},
      bracup: {},
      colors: [],
      tagsBrand: [],
      tagsColors: [],
      tagsCategories: [],
      tagsBracup: []
    }
  },
  computed: {
    ...mapGetters([
      'getCatalog',
      'getBrands',
      'getCategories',
      'getBracup',
      'getColors'
    ])
  },
  watch: {
    getBrands (data) {
      this.brands = data
    },
    getCategories (data) {
      this.categories = data
    },
    getBracup (data) {
      this.bracup = data
    },
    getColors (data) {
      this.colors = data
    },
    tagsBrand (data) {
      this.setTagsBrand(data)
    },
    tagsColors (data) {
      this.setTagsColors(data)
    },
    tagsCategories (data) {
      this.setTagsCategories(data)
    },
    tagsBracup (data) {
      this.setTagsBracup(data)
    },
  },
  methods: {
    ...mapActions([
      'setTagsBrand',
      'setTagsColors',
      'setTagsCategories',
      'setTagsBracup'
    ]),
    getFilteredBrands(text) {
      this.brands = this.brands.filter((brand) => {
        return brand.toLowerCase().indexOf(text.toLowerCase()) >= 0
      })
    },
    getFilteredColors(text) {
      this.colors = this.colors.filter((color) => {
        return color.color.toLowerCase().indexOf(text.toLowerCase()) >= 0
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
